export default {
  components : {
    contact_form : {
      honeypot_error : 'Пожалуйста, не используйте инструменты автоматической отправки.'
    }
  },
  contactForm : {
    name : "Имя",
    phone : "Телефон",
    email : "Эл. адрес",
    message : "Сообщение:",
    date : 'Свидание',
    persons : 'Количество человек',
    send : 'Отправлять',
    error : 'Ошибка',
    sending : 'Отправка',
    sent : 'Отправил',
    toastr : {
      error : 'Ошибка при отправке сообщения',
      nameRequired : 'Пожалуйста, укажите ваше имя',
      emailRequired : 'Пожалуйста, укажите адрес электронной почты',
      recaptchaFailed : 'Ошибка! Пожалуйста, попробуйте еще раз.'
    }
  }
}
